<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <h3>{{report.title}}</h3>
                </v-flex>
                <v-flex xs12>
                    <v-form @submit.prevent="getData">
                        <v-card v-if="report.show_btn !== 'hide'">
                            <v-card-title>
                                <h5>فیلتر‌ها</h5>
                            </v-card-title>

                            <v-card-text>
                                <v-layout row fill-height wrap v-if="loadedItems">
                                    <v-flex v-bind:key="i" v-for="(field,i) in filters" :class="`md` + field.col">
                                        <v-text-field
                                                v-if="field.field_type === 'textinput' || field.field_type === 'numeric'"
                                                :label="field.field_fa_name.replace('ltr','',-1)"
                                                :name="field.name"
                                                :type="field.field_type === 'numeric'?'number':'text'"
                                                :data-ltr="field.field_fa_name.includes('ltr')"
                                                v-model="filterData[field.name]"
                                        ></v-text-field>
                                        <v-textarea
                                                v-else-if="field.field_type === 'textarea'"
                                                :label="field.field_fa_name.replace('ltr','',-1)"
                                                :name="field.name"
                                                :data-ltr="field.field_fa_name.includes('ltr')"
                                                v-model="filterData[field.name]"
                                        ></v-textarea>
                                        <v-autocomplete
                                                v-else-if="field.field_type.includes('select') && setting[field.id].items.length >0"
                                                :items="setting[field.id].items"
                                                :item-text="setting[field.id].text"
                                                :item-value="setting[field.id].value_index"
                                                :multiple="field.field_type === 'multiple_select'"
                                                :label="field.field_fa_name"
                                                :name="field.name"
                                                v-model="filterData[field.name]"
                                        ></v-autocomplete>
                                        <v-radio-group v-else-if="field.field_type === 'radio'"
                                                       v-model="filterData[field.name]">
                                            <v-layout>
                                                <v-flex>{{field.field_fa_name}}:</v-flex>
                                                <v-flex :key="field.id + `_` + op.id"
                                                        v-for="(op,i) in setting[field.id].items">
                                                    <v-radio
                                                            :label="op.val"
                                                            :value="op.id"
                                                    ></v-radio>
                                                </v-flex>
                                            </v-layout>
                                        </v-radio-group>
                                        <v-checkbox v-else-if="field.field_type === 'checkbox'"
                                                    v-model="filterData[field.name]"
                                                    :value="field.default_value"
                                                    :label="field.field_fa_name"></v-checkbox>
                                        <div v-else-if="field.field_type === 'JalaliDateTimePeriod'">
                                            <v-layout row wrap>
                                                {{field.field_fa_name}}
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex>
                                                    <date-picker
                                                            placeholder="از تاریخ"
                                                            type="datetime"
                                                            format="jYYYY/jMM/jDD HH:mm"
                                                            editable
                                                            v-model="filterData[field.name].from"
                                                    ></date-picker>
                                                </v-flex>
                                                <v-flex>
                                                    <date-picker
                                                            placeholder="تا تاریخ"
                                                            type="datetime"
                                                            format="jYYYY/jMM/jDD HH:mm"
                                                            editable
                                                            v-model="filterData[field.name].to"
                                                    ></date-picker>
                                                </v-flex>
                                            </v-layout>
                                        </div>

                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout row wrap>
                                    <v-flex xs3 v-if="report.sorts.length > 0">
                                        <v-autocomplete
                                                :items="report.sorts"
                                                item-text="text"
                                                item-value="val"
                                                label="مرتب سازی برحسب"
                                                v-model="sort"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                block
                                                color="green"
                                                class="mt-3"
                                                style="color:white"
                                                @click="getData">
                                            <v-icon>search</v-icon>
                                            &nbsp;
                                            مشاهده
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                    <v-card>
                        <v-toolbar v-if="report.local_search" card color="white">
                            <v-text-field
                                    class="hidden-sm-and-down"
                                    flat
                                    hide-details
                                    placeholder="جستجوی محلی..."
                                    prepend-icon="search"
                                    solo
                                    v-model="search"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider v-if="report.local_search"></v-divider>
                        <v-data-table
                                :rows-per-page-items="[25,50,100,250,500,{text:'همه','value':-1}]"
                                :search="search"
                                :itemsPerPage="25"
                                :headers="headers"
                                :items="items"
                                :pagination.sync="pagination"
                                :loading="loading"
                                class="elevation-1"
                        >
                            <template v-slot:items="props">
                                <td v-for="(header,k) in headers" v-bind:key="`rows_`+k"
                                    :style="`text-align:` + header.align">
                                    <div v-if="header.action.length === 0">
                                        {{ props.item[header.value]}}
                                    </div>
                                    <div v-else>
                                        <v-btn v-if="header.action === 'show'"
                                               @click="$router.push(props.item[header.value])"
                                               color="primary" dark depressed fab icon
                                               outline small>
                                            <v-icon>visibility</v-icon>
                                        </v-btn>
                                        <v-btn v-else-if="header.action === 'edit'"
                                               @click="$router.push(props.item[header.value])"
                                               color="primary" dark depressed fab icon
                                               outline small>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-else-if="header.action === 'delete'"
                                               color="pink" dark depressed fab icon outline small
                                               @click="DeleteEntity($route.params.rpath,props.item[header.value])">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <v-img v-else-if="header.action === 'img'"
                                               :src="props.item[header.value]"
                                               max-height="70"
                                               aspect-ratio
                                        ></v-img>
                                        <v-btn v-else-if="header.action === 'func'"
                                               :color="props.item[header.value].split('|')[1]" dark depressed fab icon
                                               outline small @click="callFunc(props.item[header.value])">
                                            <v-icon>{{props.item[header.value].split('|')[0]}}</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                            </template>
                            <template v-slot:no-data>
                                <v-alert :value="true" color="warning" icon="warning">
                                    متاسفانه‌ داده‌ای با این فیلتر وجود ندارد!
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-card>
                    <v-card v-if="report.downloadable === 1">
                        <v-card-actions>
                            <v-layout>
                                <v-flex>
                                    <v-btn
                                            :loading="excel_loading"
                                            :disabled="excel_loading"
                                            @click="Download('excel')"
                                            block
                                            color="purple"
                                            style="color:white"
                                    >دانلود با فرمت Excel
                                    </v-btn>
                                </v-flex>
                                <v-flex>
                                    <v-btn
                                            :loading="csv_loading"
                                            :disabled="csv_loading"
                                            @click="Download('csv')"
                                            block
                                            color="blue"
                                            style="color:white">دانلود با فرمت CSV
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import VWidget from '@/components/VWidget';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import saveAs from 'file-saver';

export default {
  name: 'Report',
  components: {
    VWidget: VWidget,
    datePicker: VuePersianDatetimePicker
  },
  data () {
    return {
      loadedItems: true,
      bulk_limit: 500,
      csv_loading: false,
      excel_loading: false,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      report: {
        id: 0,
        title: '',
        module: '',
        show_btn: 'manual',
        report_path: '',
        downloadable: 1,
        local_search: 1,
        row_per_page: 25,
        sorts: []
      },
      search: '',
      sort: '',
      total_items: 0,
      items: [],
      filters: [],
      setting: {},
      filterData: {},
      loading: false,
      pagination: {
        rowsPerPage: 25
      },
      headers: []
    };
  },
  watch: {
    $route () {
      this.getReportInfo();
    },
  },
  mounted () {
    this.getReportInfo();
  },
  methods: {
    callFunc (data) {
      if (typeof data !== 'string') {
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        this.snackbar.text = 'خطا در بازخوانی اطلاعات تابع';
        return;
      }
      let input = data.split('|');
      if (input.length < 4) {
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        this.snackbar.text = 'اطلاعات تابع نامعتبر است.';
        return;
      }
      this[input[2]](input[3]);
    },
    async getData () {
      this.loading = true;
      this.items = [];
      this.total_items = 0;
      let pr = null;
      // GET Data
      try {
        pr = await this.getDataFromApi(1);
      } catch (e) {
        this.loading = false;
        this.snackbar = HttpErrorToSnackbar(e);
        return;
      }
     
      this.total_items = pr.data.info.total;
      if (pr.data.rows !== null) {
        this.items = this.items.concat(pr.data.rows);
      }
      for (let i = 2; i <= Math.ceil(this.total_items / this.bulk_limit); i++) {
        try {
          pr = await this.getDataFromApi(i);
        } catch (e) {
          this.loading = false;
          this.snackbar = HttpErrorToSnackbar(e);
          return;
        }
        if (pr.data.rows !== null) {
          this.items = this.items.concat(pr.data.rows);
        }
      }
      this.loading = false;
    },
    getDataFromApi (page) {
      this.loading = true;
      return this.axios.post('/reseller/report_data/', {
        filter: this.filterData,
        limit: this.bulk_limit,
        offset: (page - 1) * this.bulk_limit,
        sort: this.sort,
        path: this.$route.params.rpath,
      });
    },
    getReportInfo () {
      this.sort = '';
      this.axios.get('/reseller/report/' + this.$route.params.rpath)
        .then(response => {
          this.headers = [];
          this.report = response.data.report;
          if (this.report.sorts === null) {
            this.report.sorts = [];
          }
          if (this.report.sorts.length > 0) {
            this.sort = this.report.sorts[0].val;
          }
          this.filters = response.data.filters.filter(f => f.field_type !== 'Hidden');
          this.makeFiltersIndex();
          this.pagination.rowsPerPage = this.report.row_per_page;
          response.data.columns.forEach(c => {
            this.headers.push({
              text: c.label,
              align: c.align,
              sortable: c.sortable === 'Y',
              value: c.name,
              action: c.action_btn
            });
          });
          // fetch auto reports
          if (this.report.show_btn.includes('auto')) {
            this.getData();
          }
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    makeFiltersIndex () {
      this.filterData = {};
      this.filters.forEach(f => {
        if (f.field_type.indexOf('Period') > -1) {
          this.filterData[f.name] = {
            from: '',
            to: ''
          };
        } else {
          this.filterData[f.name] = f.default_value;
        }


        // Fetch select data
        if (f.field_type.includes('select')) {
          // multiple default value
          if (f.field_type.includes('multiple')) {
            this.filterData[f.name] = f.default_value.split(',');
          }
          this.setting[f.id] = {
            items: [],
            text: '',
            value_index: '',
          };
          f.data_items = f.data_items.replace('\r', '', -1);

          this.setting[f.id].value_index = 'id';
          this.setting[f.id].text = 'val';

          let items = f.data_items.split('\n');
          if (f.data_items.indexOf('***') > -1) {
            if (items.length === 2) {
              this.loadedItems = false;
              this.axios.get('/reseller/' + items[0].split('|')[1] + '/').then(response => {
                if (typeof response.data.data === 'undefined') {
                  this.setting[f.id].items = response.data.Data;
                } else {
                  this.setting[f.id].items = response.data.data;
                }

                let indexes = items[1].split('|')[1].split(' ');
                this.setting[f.id].items.map(item => {
                  let vals = [];
                  // eslint-disable-next-line max-nested-callbacks
                  indexes.forEach(i => {
                    vals.push(item[i]);
                  });
                  item.val = vals.join(' ');
                  return item;
                });
                if (items[0].split('|')[0].length === 4) {
                  const n = items[1].split('|')[0];
                  const starter = this.setting[f.id].items[0];
                  starter[n] = '';
                  starter.val = '*** همه ***';
                  this.setting[f.id].items = [starter].concat(this.setting[f.id].items);
                }
              }).catch(error => {
                this.snackbar = HttpErrorToSnackbar(error);
              }).finally(() => {
                this.loadedItems = true;
              });
              this.setting[f.id].value_index = items[1].split('|')[0];
            }
          } else {
            items.forEach((item) => {
              this.setting[f.id].items.push({
                id: item.split('|')[0],
                val: item.split('|')[1],
              });
            });
            this.setting[f.id].value_index = 'id';
          }
        }

        // Radio Data
        if (f.field_type.includes('radio')) {
          this.setting[f.id] = {
            items: [],
          };
          if (f.data_items.length > 0) {
            let items = f.data_items.split('\n');
            items.forEach((item) => {
              this.setting[f.id].items.push({
                id: item.split('|')[0],
                val: item.split('|')[1],
              });
            });
          }
        }
      });
    },
    Download: function (format) {
      if (format === 'excel') {
        this.excel_loading = true;
      } else {
        this.csv_loading = true;
      }
      this.axios.request({
        url: '/reseller/report_download/',
        method: 'POST',
        data: {
          filter: this.filterData,
          sort: this.sort,
          format: format,
          path: this.$route.params.rpath,
        },
        responseType: 'blob',
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/zip' });
        saveAs(blob, this.$route.params.rpath + (format === 'excel' ? '.xlsx.zip' : '.csv.zip'));
      }).catch(() => {
        this.snackbar.text = 'خطا در ارتباط';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
      }).finally(() => {
        if (format === 'excel') {
          this.excel_loading = false;
        } else {
          this.csv_loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/reports/Report.vue